<template>
  <div class="col-12">
    <ul class="nav nav-tabs align-items-center row">
      <li v-for="tab in tabs" :key="tab" class="nav-item" :class='numColumns'>
        <a class="nav-link" :class="{ active: tab === selected}" @click="setTab(tab)">{{ tab }}</a>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'TabNav',
    props: {
      tabs: {
        type: Array,
        required: true,
      },
      selected: {
        type: String,
        required: true,
      }
    },
    computed:{
        numColumns(){
            return 'col-'+ Math.floor(12/this.$props.tabs.length);
        }
    },
    methods: {
      setTab(tab) {
        let bodyTag = document.body;
        bodyTag.style.overflow = 'auto';
        this.$emit('selected', tab);
      },
    },
  };
</script>
